import "./badge.scss";

interface UiBadgeProps {
  variant: string | "active" | "inactive" | "terminate" | "pending";
  children: React.ReactNode;
  className?: string;
}

export function UiBadge({ children, variant, className }: UiBadgeProps) {
  return (
    <span className={`ui-badge ${variant} ${className || ""}`}>{children}</span>
  );
}
